import cn from 'clsx';
import { FC, SyntheticEvent, useState } from 'react';

import s from './Switch.module.scss';

type SwitchChangeEventHandler = (checked: boolean, event?: SyntheticEvent<HTMLButtonElement>) => void;
export interface SwitchProps {
  defaultChecked?: boolean;
  disabled?: boolean;
  onChange: SwitchChangeEventHandler;
}

const Switch: FC<React.PropsWithChildren<React.PropsWithChildren<SwitchProps>>> = ({ defaultChecked = false, disabled = false, onChange }) => {
  const [isOn, setOn] = useState(defaultChecked);

  const handleClick = () => {
    setOn(!isOn);
  };
  const handleChange = (e: SyntheticEvent<HTMLButtonElement>) => {
    onChange(isOn, e);
  };

  return (
    <button
      disabled={disabled}
      defaultChecked={defaultChecked}
      aria-label={isOn ? 'Switch is on' : 'Switch is off'}
      type="button"
      className={cn(s.switch, {
        [s.on as string]: isOn,
        [s.off as string]: !isOn
      })}
      onClick={handleClick}
      onChange={handleChange}
    >
      <span className={s.circle} />
    </button>
  );
};

export default Switch;
